import { gql } from '@apollo/client';

export const BASE_ASK_RESPONSE = gql`
  fragment BaseAskResponse on Answer {
    answer
    sessionId
  }
`;

export const BASE_RATE_ANSWER_RESPONSE = gql`
  fragment BaseRateAnswerResponse on Rating {
    status
  }
`;

export const ASK_QUESTION = gql`
  mutation askQuestion($input: AskQuestionInput!) {
    askQuestion(input: $input) {
      ...BaseAskResponse
    }
  }
  ${BASE_ASK_RESPONSE}
`;

export const RATE_ANSWER = gql`
  mutation rateAnswer($input: RateAnswerInput!) {
    rateAnswer(input: $input) {
      ...BaseRateAnswerResponse
    }
  }
  ${BASE_RATE_ANSWER_RESPONSE}
`;
